import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../FontAwesomeIcons";
import {CategoriaQuickPickerCard} from "./CategoriaQuickPickerCard";
import Page from "../../BaseComponents/Page/Page";
import DiscountBoxToWarnUser from "../../DiscountBoxToWarnUser";
import {ServicesSearchView} from "../ServicesSearch/ServicesSearchView";
import {flattedCategoryTree} from "../helpers/categorie";
import {PluralString} from "../../../helpers/UIUtility";
import {swalError} from "../../../helpers/SweetAlertWrapper";
import {
    FloatingShoppingCartIcon,
    ServiziShoppingCartItem,
    ShoppingCartBackdrop,
    ShoppingCartContainer,
    ShoppingCartFooter,
    ShoppingCartIcon
} from "../ServiziPicker/ServiziChooserPage";
import {PageFooter, PageWithFooterContainer} from "../../BaseComponents/Page/PageFooter";

export class CategoryPickerPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            idCategoriaSelected: null,
            shoppingCartOpen: false
        }
    }

    componentDidUpdate(prevProps) {
        //Chiude il carrello se non ci sono più servizi da mostrare (es. ho eliminato l'ultimo servizio dal carrello)
        const prevSelectedCount = (prevProps.selectedServiceIds || []).length;
        const currentSelectedCount = (this.props.selectedServiceIds || []).length;
        if (prevSelectedCount && !currentSelectedCount && this.state.shoppingCartOpen) {
            this.setState({shoppingCartOpen: false});
        }
        if (prevProps.shoppingCartEnabled && !this.props.shoppingCartEnabled && this.state.shoppingCartOpen) {
            this.setState({shoppingCartOpen: false});
        }
    }

    handleSubcategorySelect = id_categoria => {
        const category = this.props.categoryTree.find(c => c.id_categoria === id_categoria);
        if (!category) return;
        if (!category.child || category.child.length === 0) {
            this.props.onLeafChoose(id_categoria);
        } else {
            this.setState({idCategoriaSelected: id_categoria});
        }
    }

    handleSubcategoryDismiss = _ => this.setState({idCategoriaSelected: null});

    getSelectedCategorySubtree = _ => {
        const category = this.props.categoryTree.find(c => c.id_categoria === this.state.idCategoriaSelected);
        return category.child || [];
    }

    hasSelectedServices = _ => (this.props.selectedServiceIds || []).length > 0;

    toggleShoppingCart = _ => {
        if (!this.props.shoppingCartEnabled) return;
        if (!this.hasSelectedServices()) return;
        this.setState({shoppingCartOpen: !this.state.shoppingCartOpen});
    }

    getSelectedServices = _ => {
        const selectedIds = this.props.selectedServiceIds || [];
        return selectedIds
            .map(id => this.props.services.find(s => s.id_servizio === id))
            .filter(Boolean);
    }

    handleRemove = id_servizio => {
        const selectedIds = this.props.selectedServiceIds || [];
        const updatedIds = selectedIds.filter(id => id !== id_servizio);
        if (this.props.onSelectedServicesChange) {
            this.props.onSelectedServicesChange(updatedIds);
        }
    }

    getTotale = _ => {
        return this.getSelectedServices().reduce((acc, servizio) => {
            const prezzoBase = parseFloat(servizio.prezzo);
            const prezzoScontato = prezzoBase - (prezzoBase * parseFloat(servizio.perc_sconto) / 100);
            return acc + prezzoScontato;
        }, 0.0);
    }

    handleCartConfirm = event => {
        if (event) event.preventDefault();
        const selectedIds = this.props.selectedServiceIds || [];
        if (!selectedIds.length) {
            swalError("Devi scegliere almeno un servizio per poter proseguire");
            return;
        }
        this.setState({shoppingCartOpen: false});
        if (this.props.onCartConfirm) this.props.onCartConfirm();

    }

    render() {
        const categoriesList = this.props.categoriesList || flattedCategoryTree(this.props.categoryTree, "child");
        const selectedServices = this.getSelectedServices();
        return (
            <Fragment>
                <Page
                    title={"Prenota"}
                    active={true}
                    leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                    onLeftIconClick={this.props.onDismiss}
                >
                    <div style={{paddingBottom: 80}}>
                        {
                            !this.props.hideSearch ?
                            <ServicesSearchView
                                services={this.props.services}
                                showPrices={this.props.showPrices}
                                showDuration={this.props.showDuration}
                                showImage={this.props.showImage}
                                showDescription={this.props.showDescription}
                                onSelectedServicesChange={this.props.onSelectedServicesChange}
                                selectedServiceIds={this.props.selectedServiceIds}
                                categoriesList={categoriesList}
                            /> : <br/>
                        }

                        {/*Stampo box per far capire la presenza di uno sconto esterno*/}
                        {this.props.promotionDiscount &&
                            <DiscountBoxToWarnUser discount={this.props.promotionDiscount}/>}

                        <div className={"container"}>
                            {this.props.categoryTree.map(c =>
                                <CategoriaQuickPickerCard
                                    key={c.id_categoria}
                                    itemData={c}
                                    onChoose={this.handleSubcategorySelect}
                                />
                            )}
                        </div>

                        <PageFooter
                            className={`bg-main-z2 p-3 border-top ${this.props.shoppingCartEnabled && selectedServices.length > 0 ? '' : 'd-none'}`}>
                            <div className={"d-flex align-items-center justify-content-between"}>
                                <button
                                    type={"button"}
                                    className={"btn btn-lg btn-block btn-primary text-on-bg-primary"}
                                    onClick={this.handleCartConfirm}
                                >
                                    Continua <FaSolidIcon name={"chevron-right"}/>
                                </button>
                                <div className={"ml-3"}>
                                    <ShoppingCartIcon onClick={this.toggleShoppingCart}
                                                      className={"bg-secondary text-on-bg-secondary rounded-circle d-flex align-items-center justify-content-center"}>
                                        {
                                            this.state.shoppingCartOpen ?
                                                <FaSolidIcon name={"times"}/>
                                                :
                                                <FaSolidIcon name={"list"} badge={selectedServices.length}
                                                             badgeColor={"secondary"}/>
                                        }
                                    </ShoppingCartIcon>
                                </div>
                            </div>
                        </PageFooter>
                    </div>
                </Page>

                {
                    this.state.shoppingCartOpen && this.props.shoppingCartEnabled && selectedServices.length ?
                        [
                            <ShoppingCartBackdrop className={"__androidDismissable__"} key={"cart-backdrop"}
                                                  onClick={this.toggleShoppingCart}/>,
                            <ShoppingCartContainer key={"cart-container"}
                                                   className={"bg-main-z2 rounded shadow p-3"}>
                                <h3 className={"text-on-bg-main"}>Servizi scelti</h3>
                                <div className={"list-group list-group-flush"}>
                                    {
                                        selectedServices.map(servizio => (
                                            <ServiziShoppingCartItem
                                                key={servizio.id_servizio}
                                                servizio={servizio}
                                                onRemove={this.handleRemove}
                                                showPrice={this.props.showPrices}
                                            />
                                        ))
                                    }
                                </div>
                                <ShoppingCartFooter className={"p-3 bg-main-z2 border-top"}>
                                    {
                                        !!this.props.maxRepeat && <div className={"form-group"}>
                                            Prenota contemporaneamente per&nbsp;
                                            <select name={"repeat"} onChange={this.props.onRepeatChange}
                                                    value={this.props.repeat}>
                                                {
                                                    [...new Array(this.props.maxRepeat)].map((_, i) =>
                                                        <option key={i} value={i + 1}>{i + 1}</option>
                                                    )
                                                }
                                            </select> <PluralString more={"persone"} single={"persona"}
                                                                    n={this.props.repeat}/>
                                        </div>
                                    }

                                    <button type={"button"} className={"btn btn-primary btn-block"}
                                            onClick={this.handleCartConfirm}>
                                        <FaSolidIcon name={"check"}/> Avanti
                                        {
                                            this.props.showPrices &&
                                            <span>&nbsp;(€{this.getTotale().toFixed(2)})</span>
                                        }
                                    </button>
                                </ShoppingCartFooter>
                            </ShoppingCartContainer>,
                            <FloatingShoppingCartIcon onClick={this.toggleShoppingCart} key={"cart-toggle"}
                                                      className={"bg-secondary text-on-bg-secondary rounded-circle d-flex align-items-center justify-content-center"}>
                                <FaSolidIcon name={"times"}/>
                            </FloatingShoppingCartIcon>
                        ]
                        : ''
                }


                {
                    !!this.state.idCategoriaSelected &&
                    <CategoryPickerPage
                        categoryTree={this.getSelectedCategorySubtree()}
                        onDismiss={this.handleSubcategoryDismiss}
                        onLeafChoose={this.props.onLeafChoose}
                        services={this.props.services}
                        showPrices={this.props.showPrices}
                        showDuration={this.props.showDuration}
                        showImage={this.props.showImage}
                        showDescription={this.props.showDescription}
                        onSelectedServicesChange={this.props.onSelectedServicesChange}
                        selectedServiceIds={this.props.selectedServiceIds}
                        categoriesList={categoriesList}
                        shoppingCartEnabled={this.props.shoppingCartEnabled}
                        onCartConfirm={this.props.onCartConfirm}
                        repeat={this.props.repeat}
                        maxRepeat={this.props.maxRepeat}
                        onRepeatChange={this.props.onRepeatChange}
                    />
                }
            </Fragment>
        )
    }

}

CategoryPickerPage.propTypes = {
    categoryTree: PropTypes.array,
    onDismiss: PropTypes.func,
    onLeafChoose: PropTypes.func,
    hasPromotion: PropTypes.bool,
    services: PropTypes.arrayOf(PropTypes.object),
    onSelectedServicesChange: PropTypes.func,
    selectedServiceIds: PropTypes.arrayOf(PropTypes.any),
    showPrices: PropTypes.bool,
    showDescription: PropTypes.bool,
    showDuration: PropTypes.bool,
    showImage: PropTypes.bool,
    categoriesList: PropTypes.array,
    shoppingCartEnabled: PropTypes.bool,
    onCartConfirm: PropTypes.func,
    repeat: PropTypes.number,
    maxRepeat: PropTypes.number,
    onRepeatChange: PropTypes.func,
    hideSearch: PropTypes.bool,
}
